import React from 'react';
import SectionTwoList from "./SectionTwoList";

const SectionTwo = () => {
    return (
        <SectionTwoList/>
    )
}

export default SectionTwo
